import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SyncUpdateService } from 'sync-update';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  notifCount: BehaviorSubject<number> = new BehaviorSubject(0);
  syncUpdateService: SyncUpdateService;

  constructor(private injector: Injector) {
    this.syncUpdateService = this.injector.get(SyncUpdateService, null);
    this.getNotifCount();
  }

  getNotifMode() {
    return localStorage.getItem('notifMode');
  }

  getNotifCount() {
    // this.socketService.getNotification().subscribe(() => {
    //   new ClientNotificationsRequest.List({
    //     userId: this._userService?.getUserDetail()?.realPerson?.id,
    //     limit: 100,
    //   })
    //     .call()
    //     .pipe(
    //       filter((value) => !!value),
    //       map((value) => value?.response?.data),
    //     )
    //     .subscribe((value) => {
    //       this.notifCount.next(value.length);
    //     });
    // });
  }

  get notificatilnCount(): string {
    return this.notifCount.value.toString();
  }
}
